import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        selected: {},
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('tpp/domains', {
                params: rootState.route.query
            });

            commit('setItems', response.data);

            return response;
        },
        async check({ commit }, payload) {
            const response = await http.get('tpp/domains/check', {
                params: payload
            });

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('tpp/domains', payload);

            return response;
        },
        async sync({ commit }) {
            const response = await http.get('tpp/domains/sync');

            commit('setItems', response.data);

            return response;
        },
        async updateNameServers({ commit }, payload) {
            const response = await http.patch(`tpp/domains/${payload.domainId}/nameservers`, payload);

            return response;
        },
        async updateContact({ commit }, payload) {
            const response = await http.patch(`tpp/domains/${payload.DomainId}/contact`, payload);

            return response;
        },
        async renew({ commit }, payload) {
            const response = await http.post(`tpp/domains/renew`, payload);

            return response;
        },
    }
}